import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { injectIntl, FormattedMessage } from "react-intl";
import { DownloadButton } from "components/buttons";
import useRecordingFilePath from "./use-recording-file-path";
import withStyles from "components/with-styles";
import styles from "./styles/download-recording.css.js";
import { useCurrentCustomerContext } from "components/current-customer-context";
import { useAuthDataContext } from "components/auth";
import { useLoadingContext } from "components/loading-spinner-overlay";
import {
  DOWNLOAD_STATUS_ERROR,
  DOWNLOAD_STATUS_INPROGRESS,
  DOWNLOAD_STATUS_UNKNOWN,
  STATUS_PENDING
} from "../../../utils/constants";
import {getDownloadUrlService} from "../../../services/commonService";

const getRecordingFile = ({ recordingFileId, recording }) => {
  const recordingFiles = recording && recording.availableFiles ? recording.availableFiles : [];

  const defaultDownload = recordingFiles.length > 0 ? recordingFiles[0] : null;
  const recordingFile = recordingFileId ? recordingFiles.first(file => file.id === recordingFileId) : null;

  return recordingFileId ? recordingFile : defaultDownload;
};

const DownloadRecordingFile = ({ recording, recordingFileId, onlyIcon, classes, mainRecording, disabled, handleSetWarningText }) => {
  const { setLoading } = useLoadingContext();
  const { currentCustomerId } = useCurrentCustomerContext();
  const { hasAdminPrivileges } = useAuthDataContext();

  const downloadFile = getRecordingFile({ recordingFileId, recording });
  const fileUrl = useRecordingFilePath(recording.id, downloadFile?.fileId);
  const enabledDownload = (downloadFile?.downloadAvailable !== null && downloadFile?.downloadAvailable) || !disabled;

  const skip = !recording.id || (!currentCustomerId && !hasAdminPrivileges);

  const downloadFilesStatus = status=> {
    switch (status) {
    case DOWNLOAD_STATUS_INPROGRESS:
      return <FormattedMessage id="recording.download.waiting"/>
      break;
    case DOWNLOAD_STATUS_ERROR:
      return <FormattedMessage id="recording.download.error"/>
      break;
    case DOWNLOAD_STATUS_UNKNOWN:
      return <FormattedMessage id="recording.download.waiting"/>
      break;
    default:
      return null
  }}

  const handleDownloadResponse = data => {
    data.download_url === STATUS_PENDING ?
      handleSetWarningText(recording.id) :
      window.location.href = data.download_url;

    setLoading(false);
  };

  const handleDownloadError = error => {
    console.error(error);
    setLoading(false);
  };

  const handleClick = useCallback(
      e => {
        setLoading(true);
        e.stopPropagation();
        if (enabledDownload && !skip) {
          getDownloadUrlService(recording.id, handleDownloadResponse, handleDownloadError);
        }
      },
      [ currentCustomerId, enabledDownload, recording.id, recordingFileId, setLoading, skip]
  );

  return downloadFile?.fileId ? (
    <>
      <DownloadButton
        disabled={!enabledDownload}
        onClick={handleClick}
        onlyIcon={onlyIcon}
        url={downloadFile?.downloadAvailable === null ? fileUrl : undefined}
        disabledClass={mainRecording ? classes.recording_download__main__disabled : null}
      />
      <div className={classes.waitingText}>
        {!enabledDownload && <>{downloadFilesStatus(downloadFile.downloadStatus)}</>}
      </div>
    </>
  ) : null;
};

DownloadRecordingFile.propTypes = {
  /**
   * Data to represent
   **/
  recording: PropTypes.object,
  /**
   * Shows as a simple icon
   **/
  onlyIcon: PropTypes.bool,
  /**
   * Indica si es la grabación principal
   **/
  mainRecording: PropTypes.bool,
  /**
   * String del fichero de grabación
   **/
  recordingFileId: PropTypes.string,
};

export default injectIntl(withStyles(styles)(DownloadRecordingFile));
